import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import type { FC } from 'react';

interface SafeAndSecureProps {
  className?: string;
}
export const SafeAndSecure: FC<SafeAndSecureProps> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <div className={className}>
      <h3 className="text-center">{t('safety.title')}</h3>
      <div className="mt-[41px] flex flex-col items-center justify-center gap-12  sm:flex-row sm:items-start sm:gap-0">
        <div className="flex max-w-[298.5px] flex-col items-center px-6 text-center lg:px-0">
          <Image
            src="/assets/deposit/guarantee.png"
            alt="guarantee"
            height={128}
            width={128}
          />
          <p className="body2-bold mt-[7px] tracking-[0.2px] text-blue-900">
            {t('safety.guarantee.title')}
          </p>
          <p className="body3 mt-[8px] tracking-[0.1px] text-grey-800">
            {t('safety.guarantee.description')}
          </p>
        </div>
        <span className="hidden h-[160px] w-[1px] shrink-0 self-center bg-blue-150 sm:mx-3 sm:block lg:ml-[76px] lg:mr-[67px] xl:mx-[82px]" />
        <div className="flex max-w-[317.5px] flex-col items-center px-6 text-center lg:px-0">
          <Image
            src="/assets/deposit/secure.png"
            alt="guarantee"
            height={128}
            width={128}
          />
          <p className="body2-bold mt-[7px] tracking-[0.2px] text-blue-900">
            {t('safety.encryption.title')}
          </p>
          <p className="body3 mt-[8px] tracking-[0.06px] text-grey-800">
            {t('safety.encryption.description')}
          </p>
        </div>
      </div>
    </div>
  );
};
